<template>
    <div class="sidebar-logo-container" :class="{'collapse':collapse}"
         :style="{ backgroundColor: sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground }">
        <transition name="sidebarLogoFade">
            <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/home">
                <img v-if="logo" :src="logo" class="sidebar-logo"/>
                <h1 v-else class="sidebar-title"
                    :style="{ color: sideTheme === 'theme-dark' ? variables.logoTitleColor : variables.logoLightTitleColor }">
                    {{ title }} </h1>
            </router-link>
            <router-link v-else key="expand" class="sidebar-logo-link" to="/home">
                <img v-if="logo" :src="logo" class="sidebar-logo"/>
                <h1 class="sidebar-title"
                    :style="{ color: sideTheme === 'theme-dark' ? variables.logoTitleColor : variables.logoLightTitleColor }">
                    {{ title }} </h1>
            </router-link>
        </transition>
    </div>
</template>

<script>
import logoImg from '@/assets/img/HaierEnergy128.png'
import variables from "@/styles/variables.module.scss";

export default {
    name: 'SidebarLogo',
    props: {
        collapse: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        variables() {
            return variables;
        },
        sideTheme() {
            return this.$store.state.settings.sideTheme
        }
    },
    data() {
        return {
            title: 'Haier Energy',
            logo: logoImg
        }
    }
}
</script>

<style lang="scss" scoped>
// 阿里妈妈数黑体，仅用作视觉效果提升，在线失效后更换为系统默认字体或下载字体包使用
@font-face {
    font-family: "阿里妈妈数黑体 Bold";font-weight: 700;src: url("//at.alicdn.com/wf/webfont/mSSQJZI3Vkc3/KkNnDEks5fqK.woff2") format("woff2"),
    url("//at.alicdn.com/wf/webfont/mSSQJZI3Vkc3/kOF6rRD064GW.woff") format("woff");font-variation-settings: normal;font-display: swap;
}

.sidebarLogoFade-enter-active {
    transition: opacity 0;  // * 关闭动画
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
    opacity: 0;
}

.sidebar-logo-container {
    position: relative;
    width: 100%;
    line-height: 60px;
    background: #2b2f3a;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;

    & .sidebar-logo-link {
        height: 100%;
        width: 100%;

        & .sidebar-logo {
            width: 32px;
            height: 32px;
            vertical-align: middle;
            margin-right: 10px;
        }

        & .sidebar-title {
            display: inline-block;
            color: #fff;
            font-weight: 600;
            line-height: 32px;
            font-size: 16px;
            font-family: "阿里妈妈数黑体 Bold";
            font-variation-settings: normal;
            vertical-align: middle;
        }
    }

    &.collapse {
        .sidebar-logo {
            margin-right: 0px;
        }
    }
}
</style>
